import { render, staticRenderFns } from "./SortSwitch.vue?vue&type=template&id=86b8f406&scoped=true&"
import script from "./SortSwitch.vue?vue&type=script&lang=js&"
export * from "./SortSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SortSwitch.vue?vue&type=style&index=0&id=86b8f406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8f406",
  null
  
)

export default component.exports